import { useDroppable } from "@dnd-kit/core";
import React from "react";

interface DroppableProps {
  id: string;
  children: React.ReactNode;
  isDragging?: boolean;
}

const DroppableAnalytics: React.FC<DroppableProps> = ({
  id,
  children,
  isDragging,
}) => {
  const { isOver, setNodeRef } = useDroppable({ id });
  //   let boxShadowTrade =
  //     "border-1 rounded-lg border-sky-200 shadow-[0_0_2px_#fff,inset_0_0_2px_#fff,0_0_5px_#08f,0_0_15px_#08f,0_0_30px_#08f]";
  return (
    <div
      ref={setNodeRef}
      className={`border ${isOver ? "bg-sky-200 dark:!bg-green-700" : "bg-blue-500"} ${isDragging ? "border-purple-400" : ""} flex justify-center`}
      style={{
        borderWidth: isDragging ? 1 : 1,
        borderColor: isDragging ? "#bae6fd" : "",
        boxShadow: isDragging
          ? "0 0 1px #fff, inset 0 0 2px #fff, 0 0 5px #08f, 0 0 15px #08f, 0 0 8px #08f"
          : "",
      }}
    >
      {children}
    </div>
  );
};

export default DroppableAnalytics;
